export default "__VITE_ASSET__zLxozBqW__"